import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { motion } from "framer-motion";
import { fadeUp, revealProps, useReducedMotion } from "homepage-new/motion";
import { rf } from "../theme";
import { Card, Display, PushButton, Squiggle } from "../ui";
import { formatDate, statusOf } from "../cohortStatus";

export const FinalCTA = ({ leadCohort, onAction, onTalk }) => {
  const reduced = useReducedMotion();
  const status = leadCohort ? statusOf(leadCohort) : null;

  return (
    <Box component="section" id="join" sx={{ py: { xs: 7, md: 11 } }}>
      <Container maxWidth="md">
        <motion.div variants={fadeUp} {...revealProps(reduced)}>
          <Card bg={rf.amber} shadow={rf.shadowLg} sx={{ p: { xs: 3.5, md: 6 }, textAlign: "center" }}>
            <Box sx={{ display: "flex", justifyContent: "center", mb: 2.5 }}>
              <Squiggle color={rf.ink} width={110} />
            </Box>

            <Display component="h2" size={42} sx={{ mb: 2 }}>
              {leadCohort ? `Next up: ${leadCohort.title}` : "Tell us what you're trying to learn"}
            </Display>

            <Typography sx={{ fontFamily: rf.body, fontSize: { xs: 16, md: 17.5 }, color: rf.ink, lineHeight: 1.6, maxWidth: 580, mx: "auto", mb: 3.5, fontWeight: 500 }}>
              {leadCohort
                ? `${status?.label} · starts ${formatDate(leadCohort.start_date)}. Registrations close before the first class, and a batch that has started does not take latecomers.`
                : "Nothing is taking registrations right now. Leave your details and you'll hear the day the next batch opens."}
            </Typography>

            <Box sx={{ display: "flex", gap: 1.75, justifyContent: "center", flexWrap: "wrap" }}>
              {leadCohort && (
                <PushButton variant="primary" size="lg" onClick={() => onAction(leadCohort)}>
                  {status.actionLabel}
                </PushButton>
              )}
              <PushButton variant="light" size="lg" onClick={onTalk}>
                Ask a question first
              </PushButton>
            </Box>
          </Card>
        </motion.div>
      </Container>
    </Box>
  );
};

export default FinalCTA;
